// extracted by mini-css-extract-plugin
export default {"container":"DateRangePicker_container__K8AA2","selectContainer":"DateRangePicker_selectContainer__zgltl","label":"DateRangePicker_label__j8Dwn"};